var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ja-content',{attrs:{"pageTitle":_vm.contact.email}},[_c('b-row',[_c('b-col',[_c('h2',[_vm._v(_vm._s(_vm.$t("profile_information")))]),_c('ja-table',{attrs:{"head":_vm.profile.head,"items":_vm.profileItems}})],1),_c('b-col')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }